import { Action, ActionType } from "./actionTypes";

const INITIAL_STATE = {
  name: "",
  description: "",
  price: 0,
  count: 0,
  isSold: false,
}

const AssetDetailsReducer = (state: object = INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case ActionType.SET_ASSET_DETAILS:
      return {
        ...state,
        name: action.payload.name,
        description: action.payload.description,
        price: action.payload.price,
        count: action.payload.count,
        isSold: action.payload.isSold
      }

    default:
      return { ...state }
  }
}

export default AssetDetailsReducer;